import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material"

import { DialogParams } from "@/App/Equities/shared/services/dialog/dialog.service"

type Props = DialogParams

export const ConfirmDialog = ({
  isOpen,
  title,
  description,
  onCancel,
  onConfirm,
  cancelLabel,
  confirmLabel,
}: Props) => {
  return (
    <Dialog
      sx={({ palette, uisk }) => ({
        "& .MuiDialog-paper": {
          backgroundColor: palette["bg-primary"],
          width: "80%",
          maxHeight: 435,
          padding: uisk.spacing.lg,
          textAlign: "center",
        },
      })}
      maxWidth="xs"
      open={isOpen}
      onClose={onCancel}
    >
      <DialogTitle variant="Display sm/Regular">{title}</DialogTitle>

      {description && <DialogContent>{description}</DialogContent>}

      <DialogActions>
        <Button variant="primary" autoFocus onClick={onCancel}>
          {cancelLabel ?? "Cancel"}
        </Button>
        <Button variant="brand" onClick={onConfirm} color="warning">
          {confirmLabel ?? "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
